import React, { useState } from 'react'
import { Modal } from 'react-responsive-modal'

import { checklistErrorTypes } from 'constants/checklist'
import { dispatchError } from 'store/thunks/Checklist'
import { ensureMediaPermissions } from 'utils'
import { logger } from 'utils/logger'

import {
    Arrow,
    Content,
    Container,
    Header,
    Title,
    SubTitle,
    Video,
    VideoWrapper,
    Footer,
} from './styles'
import './styles.css'

import Button, { btnTypes } from '../common/Button'

const IMG_BASE = '/img/checklist/gifs'

const AVPermissionModal = ({ open, close }) => {
    const [showArrow, setShowArrow] = useState(false)

    const modalProps = {
        open,
        closeOnEsc: false,
        center: true,
        closeOnOverlayClick: false,
        showCloseIcon: false,
        classNames: {
            overlay: 'custom-av-overlay',
            modal: 'custom-av-modal',
        },
    }

    const btnProps = {
        type: btnTypes.PRIMARY,
        width: 'max-content',
        onClick: async () => {
            try {
                setShowArrow(true)
                await ensureMediaPermissions()
            } catch (error) {
                logger.error({ msg: `ensureMediaPermissions failed.`, error })
                dispatchError(checklistErrorTypes.AUDIO_VIDEO)
            } finally {
                setShowArrow(false)
                close()
            }
        },
    }

    const videoProps = {
        src: `${IMG_BASE}/chrome.desktop.permission.gif`,
    }

    if (!open) return null

    return (
        <Container>
            <Modal {...modalProps}>
                <Content>
                    <Header>
                        <Title>oh. need permissions!</Title>
                        <SubTitle>keep your video and audio ON</SubTitle>
                    </Header>
                    <VideoWrapper>
                        <Video {...videoProps} />
                    </VideoWrapper>
                    <Footer>
                        <Button {...btnProps}>grant permission</Button>
                    </Footer>
                </Content>
            </Modal>
            {showArrow && <Arrow src={`${IMG_BASE}/arrow.gif`} />}
        </Container>
    )
}

export default AVPermissionModal
